import { TintImage } from "@/components";
import { useAppProperties } from "@/hooks";
import { useResponsiveness } from "@/providers/context";
import { getUrlFromFilename } from "@/utils";

interface NavLinkProps {
  title: string;
  url: string;
  icon: string;
}

export const NavLink = ({ title, url, icon }: NavLinkProps) => {
  const { condensedNavBar } = useResponsiveness();
  const { colorSchemeColors } = useAppProperties();

  return (
    <a
      className="p2-semibold mx-5 flex h-[40px] w-[calc(100%-40px)] shrink-0 cursor-pointer items-center gap-[8px] rounded-[8px] px-3 hover:bg-surface-secondary"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <TintImage
        src={getUrlFromFilename(icon)}
        color={colorSchemeColors.grey700}
        dimensions={{ width: 20, height: 20 }}
      />
      {!condensedNavBar && <span className="text-item-secondary">{title}</span>}
    </a>
  );
};
